import store from '@/store'
import appConfig from '@/config'
import types from '@/store/types'

function noPass (code, auths = []) {
  for (let i = 0; i < auths.length; ++i) {
    if (typeof auths[i] === 'object' && auths[i][appConfig.authCodeKey] === code) return true
    if (auths[i] === code) return true
  }
  return false
}

/**
 * 按钮级的权限控制
 * @param {*} code 权限编码
 * @param {*} el 待测元素，可不填写
 */
export function has (code, el) {
  if (!code) return true
  let user
  if (store.state.user) user = store.state.user.userInfo
  if (user && code) {
    return noPass(code, user[appConfig.authsKey])
  } else if (!user && code && el) {
    return store.dispatch(types.user.GET_USER_INFO).then(user => {
      if (user && noPass(code, user[appConfig.authsKey])) {
        el.parentNode && el.parentNode.removeChild && el.parentNode.removeChild(el)
      }
    })
  }
  return false
}

export default {
  bind (el, binding) {
    if (!has(binding.value)) el.parentNode.removeChild(el)
  },
  update (el, binding) {
    if (!has(binding.value)) el.parentNode.removeChild(el)
  }
}



// WEBPACK FOOTER //
// ./src/directive/auth.js